import Install from "../../../../contents/docs/getting-started/_snippets/install.mdx";
import * as React from 'react';
export default {
  Install,
  React
};